// ================================================================
// 大師路由保護元件
// ================================================================

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useTeacher } from '../../contexts/TeacherContext';

interface TeacherRouteProps {
  children: React.ReactNode;
}

const TeacherRoute: React.FC<TeacherRouteProps> = ({ children }) => {
  const { isTeacherAuthenticated, isLoading } = useTeacher();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isTeacherAuthenticated) {
    return (
      <Navigate to="/teacher/login" state={{ from: location }} replace />
    );
  }

  return <>{children}</>;
};

export default TeacherRoute;
